export default {
  install(app) {
    const originalConfirm = app.config.globalProperties.$confirm;
    const originalAlert   = app.config.globalProperties.$alert;
    const originalPrompt  = app.config.globalProperties.$prompt;

    // Tabla de equivalencias One UI → iconos funcionales
    const ICON_MAP = {
      'one-message-box-icon--warning': 'one-icon-warning',
      'one-message-box-icon--error':   'one-icon-error-alert-hexagonal',
      'one-message-box-icon--info':    'one-icon-info-alert',
      'one-message-box-icon--success': 'one-icon-success-alert'
    };

    // Parche genérico
    const patchIcons = () => {
      const observer = new MutationObserver(() => {
        // Buscamos CUALQUIERA de los iconos rotos
        const selector = [
          '.one-message-box__status.icon-undefined.one-message-box-icon--warning',
          '.one-message-box__status.icon-undefined.one-message-box-icon--error',
          '.one-message-box__status.icon-undefined.one-message-box-icon--info',
          '.one-message-box__status.icon-undefined.one-message-box-icon--success'
        ].join(',');

        const icon = document.querySelector(selector);

        if (icon) {
          console.log("[MessageBox Patch] Icono detectado:", icon);

          // Identificar el tipo según la clase que lleva One UI
          const typeClass = Object.keys(ICON_MAP)
            .find(c => icon.classList.contains(c));

          if (typeClass) {
            const goodIcon = ICON_MAP[typeClass];

            // Quitar la clase rota
            icon.classList.remove('icon-undefined');

            // Añadir la clase que SÍ dibuja el icono
            icon.classList.add(goodIcon);

            // Aplicar estilo global (margen + tamaño)
            icon.style.fontSize = '22px';
            icon.style.marginRight = '5px';

            console.log(`[MessageBox Patch] Icono corregido → ${goodIcon}`);
          }

          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    // Parchar confirm
    app.config.globalProperties.$confirm = function (...args) {
      patchIcons();
      return originalConfirm.apply(this, args);
    };

    // Parchar alert
    app.config.globalProperties.$alert = function (...args) {
      patchIcons();
      return originalAlert.apply(this, args);
    };

    // Parchar prompt (si existe)
    if (originalPrompt) {
      app.config.globalProperties.$prompt = function (...args) {
        patchIcons();
        return originalPrompt.apply(this, args);
      };
    }
  }
};